/**
 * Dialogo do SISTEMA — substitui window.confirm/alert do navegador em todo o
 * fluxo de envio (pedido do dono). Mesmo visual do card de confirmacao de
 * saida: overlay proprio, icone com tom, acoes com o botao primario a direita.
 */
export default function Dialogo({ icone: Icone, tom = "primario", titulo, children, acoes = [], onFechar }) {
  const tons = {
    primario: "bg-primary/10 text-primary",
    alerta: "bg-amber-500/10 text-amber-500",
    erro: "bg-red-500/10 text-red-500",
  };
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onFechar?.(); }}>
      <div className="w-full max-w-sm rounded-2xl border bg-background shadow-2xl p-6 space-y-3">
        {Icone && (
          <span className={`mx-auto grid place-items-center w-12 h-12 rounded-full ${tons[tom]}`}>
            <Icone className="w-6 h-6" />
          </span>
        )}
        <h4 className="font-semibold text-lg text-center">{titulo}</h4>
        <div className="text-sm text-muted-foreground">{children}</div>
        <div className="flex gap-2 pt-1">
          {acoes.map((a, i) => (
            <button key={i} onClick={a.onClick} disabled={a.desabilitado}
              className={`flex-1 rounded-lg py-2.5 text-sm font-semibold transition-colors disabled:opacity-40 ${
                a.primario
                  ? "bg-primary text-primary-foreground"
                  : "border font-medium hover:bg-muted"}`}>
              {a.rotulo}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
